<template>
  <div>
    약관
  </div>
</template>

<script>
export default {
  mounted() {
    this.$eventHub.$emit('content-loaded')
  }
}
</script>
